import { Injectable, inject } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ADPResourceService } from 'digital-core';

@Injectable({ providedIn: 'root' })
export class ServiceRequestExitGuard implements CanDeactivate<unknown> {
  private dialog = inject(MatDialog);
  private resourceService = inject(ADPResourceService);

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (this.resourceService.getPortalSetting('Global_Restrict_GSSP_Handover').Value === 'true') {
      return true;
    }

    const nextUrl = nextState?.url || '';
    if (nextUrl.startsWith('/logout')) {
      return true;
    }

    const ref = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'ServiceRequest_Exit_Modal_Title',
        message: 'ServiceRequest_Exit_Modal_Message',
        confirmButtonText: 'Global_Button_Confirm',
        cancelButtonText: 'Global_Button_Cancel'
      } as any,
      disableClose: true
    });

    return ref.afterClosed().pipe(
      map((result) => result === true) // ensure boolean
    );
  }
}
